import tracking from "../tracking/Tracking";

export type ColorChangeTrackingLabels = {
  san_Interaction?: "product_color_change";
  san_ProductColorPosition?: number;
  san_ProductColorCount?: number;
};

function findFirstIndex(nodes: NodeListOf<Element>, classname: string): number | null {
  for (let i = 0; i <= nodes.length; i++) {
    const node = nodes[i];
    if (node.classList.contains(classname)) {
      return i;
    }
  }

  return null;
}

export function trackColorSwitch(variationId: string, tileContainer: HTMLElement): void {
  const amountColors = tileContainer.dataset.amountColors;

  const article = tileContainer.closest(".product") as HTMLElement;
  const localListPosition = article.dataset.localListPosition;

  const colorThumbs = tileContainer.querySelectorAll(".find_tile--visible .reptile_colorThumb");
  const position = findFirstIndex(colorThumbs, "reptile_colorThumb--selected");

  if (typeof position === "number" && amountColors && localListPosition) {
    const colorChangeTrackingData: ColorChangeTrackingLabels = {
      san_Interaction: "product_color_change",
    };
    const colorChangeFeatureTracking = {
      name: "change",
      features: [
        {
          id: "find_tile_" + localListPosition,
          name: "tile",
          status: "changed",
          position: +localListPosition,
          variationId: variationId,
          labels: {
            san_ProductColorPosition: position + 1,
            san_ProductColorCount: +amountColors,
          },
        },
      ],
    };
    tracking.submitAction(colorChangeTrackingData, colorChangeFeatureTracking);
  }
}
